import { combineReducers } from 'redux';
import login from './AuthReducer/loginReducer';
import viewAdminProfile from './AuthReducer/viewAdminProfileReducer';
import loading from './CommonReducer/loadingReducer';
import forgot from './AuthReducer/forgotReducer';
import updateProfile from './AuthReducer/updateProfileReducer';
import logout from './AuthReducer/logoutReducer';
import { viewPrograms, viewProgram, viewGuestListProgram, updateProgramRequest, programLevels } from './MasterDataReducer/programReducer'
import { viewAssessments, viewAssessment } from './MasterDataReducer/AssessmentReducer'
import { viewGuestUsers, viewGuestUserDetails, addNewGuest, updateGuestDetails } from './UserManagementReducer/guestUserReducer'
import { addNewTeamMember, deleteTeamMember, getDepartments, getUserRoleList, updateMultipleUserRole, updateTeamMemberDetails, viewTeamMemberDetails, viewTeamMembers } from './UserManagementReducer/TeamMemberReducer';
import { addNewUserRole, deleteUserRoleTitle, UpdateUserRoleTitle } from './UserManagementReducer/UserRoleReducer';
import { getAccessManagementList } from './UserManagementReducer/AccessManagementReducer';
import { addRecipe, addRecipeCollection, deleteMasterDataModule, editRecipe, editRecipeCollection, getRecipeCollectionList, getRecipeList, viewEditRecipeCollection, viewRecipe, viewRecipeCollectionDetails, uploadFile } from './MasterDataReducer/RecipeCollectionReducer';
import {
  getContentsList,
  viewContentDetails,
  addVideoPodcast,
  updateVideoPodcast,
  deleteVideoPodcast,
  getProgramsList,
  getCategoryList
} from './ContentmanagementReducer/videoPodcastsReducer';
import { getContentCategoryList } from './MasterDataReducer/ContentCategoryReducer';
import { getTestimonialList } from './ReportReducer/TestimonialsReducer';
import {getProgramFeedbackList, viewProgramFeedback} from './ReportReducer/ProgramFeedbackReducer'
import { addNewEvent, editEventDetails, getEventsList, viewEventDetails } from './EventsReducer/EventsReducer';
import { addNewActivity, getActivityList, getInterestedGuestList, updateActivity, viewActivityDetails } from './MasterDataReducer/ActivityReducer';
import { getGuestDinacharyaList, viewGuestDinacharya } from './ReportReducer/GuestDinacharyaReducer';
import { addUpdateUserManual, getUserManualList } from './UserManualReducer/UserManualReducer';
import { qmsDashboard } from './ReportReducer/QMSScoreboardReducer';
import { guestComments } from './ReportReducer/GuestCommentsReducer';
import { consultantRatings } from './ReportReducer/ConsultantRatingReducer';
import { queryReportReducer } from './AnalyticalReportReducer/QuerylReportReducer';
import { announcementReducer } from './ContentmanagementReducer/AnnouncementsReducer';
import { qmsFeedbackDetailsReducer } from './ReportReducer/QMSFeedbackDetailsReducer';
import { therapistNotesReducer } from './ReportReducer/TherapistNotesReducer';
import { deleteRequest } from './UserManagementReducer/DeleteRequestReducer';

const rootReducer = combineReducers({

  login: login,
  viewAdminProfile: viewAdminProfile,
  loading: loading,
  forgot: forgot,
  logout: logout,
  updateProfile: updateProfile,
  programLevels: programLevels,
  viewPrograms: viewPrograms,
  viewProgram: viewProgram,
  viewGuestListProgram: viewGuestListProgram,
  viewAssessments: viewAssessments,
  viewAssessment: viewAssessment,
  viewGuestUsers: viewGuestUsers,
  viewGuestUserDetails: viewGuestUserDetails,
  addNewGuest: addNewGuest,
  updateGuestDetails: updateGuestDetails,
  getDepartments: getDepartments,
  viewTeamMembers: viewTeamMembers,
  deleteTeamMember: deleteTeamMember,
  addNewTeamMember: addNewTeamMember,
  getUserRoleList: getUserRoleList,
  viewTeamMemberDetails: viewTeamMemberDetails,
  updateTeamMemberDetails: updateTeamMemberDetails,
  updateMultipleUserRole: updateMultipleUserRole,
  deleteUserRoleTitle: deleteUserRoleTitle,
  addNewUserRole: addNewUserRole,
  UpdateUserRoleTitle: UpdateUserRoleTitle,
  getAccessManagementList: getAccessManagementList,
  getRecipeCollectionList: getRecipeCollectionList,
  addRecipeCollection: addRecipeCollection,
  editRecipeCollection: editRecipeCollection,
  viewRecipeCollectionDetails: viewRecipeCollectionDetails,
  getRecipeList: getRecipeList,
  deleteMasterDataModule: deleteMasterDataModule,
  viewEditRecipeCollection: viewEditRecipeCollection,
  viewRecipe: viewRecipe,
  addRecipe: addRecipe,
  editRecipe: editRecipe,

  getContentsList: getContentsList,
  viewContentDetails: viewContentDetails,
  addVideoPodcast: addVideoPodcast,
  updateVideoPodcast: updateVideoPodcast,
  deleteVideoPodcast: deleteVideoPodcast,
  getProgramsList: getProgramsList,
  getCategoryList: getCategoryList,

  getContentCategoryList: getContentCategoryList,

  getEventsList: getEventsList,
  viewEventDetails: viewEventDetails,
  addNewEvent: addNewEvent,
  editEventDetails: editEventDetails,

  uploadFile: uploadFile,
  updateProgramRequest: updateProgramRequest,

  getActivityList: getActivityList,
  viewActivityDetails: viewActivityDetails,
  addNewActivity: addNewActivity,
  updateActivity: updateActivity,
  getInterestedGuestList: getInterestedGuestList,

  getTestimonialList: getTestimonialList,

  getProgramFeedbackList: getProgramFeedbackList,
  viewProgramFeedback: viewProgramFeedback,

  getGuestDinacharyaList: getGuestDinacharyaList,
  viewGuestDinacharya: viewGuestDinacharya,

  getUserManualList: getUserManualList,
  addUpdateUserManual: addUpdateUserManual,
  qmsDashboard: qmsDashboard,
  guestComments: guestComments,
  consultantRatings: consultantRatings,
  queryReportReducer: queryReportReducer,
  announcementReducer: announcementReducer,
  qmsFeedbackDetailsReducer: qmsFeedbackDetailsReducer,
  therapistNotesReducer: therapistNotesReducer,
  deleteRequestReducer: deleteRequest

});

export default rootReducer;
